<template>
  <transition name="slide-fade">
    <div class="slide-in-panel" v-if="notifPanel || searchPanel">
      <div class="slide-in-container">
        <div
          class="modal-header"
          :style="{ backgroundImage: 'url('+require('@/assets/ModalBackgroundImage.png')+ ')' }"
        >
          <span>
            {{ notifPanel ? $t('notification.slideInPanel.notifications') : null }}
            {{ searchPanel ? $t('notification.slideInPanel.search') : null }}
          </span>
          <div
            @click="closePanel"
            class="close-button"
          >
            <img
              alt="close-icon"
              id="close-icon"
              src="@/assets/CloseWhite.svg"
            />
          </div>
        </div>
        <div v-if="notifPanel" class="body">
          <div class="task-bar" v-show="notifications.length > 0">
            <span class="all-read" @click="markAllRead">{{ $t('notification.slideInPanel.markEverythingAsRead') }}</span> |
            <span class="all-delete" @click="deleteAllNotifications">{{ $t('notification.slideInPanel.deleteAllNotifications') }}</span>
          </div>
          <div class="no-notif" v-if="notifications.length === 0">
            {{ $t('notification.slideInPanel.noNotifications') }}
          </div>
          <transition-group name="list" tag="p">
            <div v-for="notif in notifications" :key="notif.id" class="notif-line">
              <notif-line :class="notif.isRead === false ? 'notif-unread' : 'notif-read'" :notif="notif" />
            </div>
          </transition-group>
        </div>
        <div v-if="searchPanel" class="body">
          <div class="task-bar"></div>
          <search />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import NotifLine from '@/components/notification/NotifLine'
import Search from '@/components/search/Search'

export default {
  name: 'SlideInPanel',
  components: { NotifLine, Search },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      user: state => state.user.user,
      notifPanel: state => state.notification.notifPanel,
      searchPanel: state => state.notification.searchPanel,
      notifications: state => state.notification.notifications
    })
  },
  updated() {
    if (this.notifPanel || this.searchPanel) {
      document.body.classList.toggle('noscroll', true)
    } else {
      document.body.classList.remove('noscroll', true)
    }
  },
  methods: {
    closePanel () {
      this.$store.commit('closePanel')
      this.$store.dispatch('resetSearch')
      document.body.classList.remove('noscroll', true)
    },
    markAllRead () {
      this.$store.dispatch('markAllNotificationsAreRead', this.user.id)
    },
    deleteAllNotifications () {
      this.$store.dispatch('deleteAllNotifications')
    }
  }
}
</script>

<style scoped lang="scss">
.slide-in-panel{
  z-index: 1;
}

  .slide-in-container {
    position:fixed;
    background-color: white;
    height:100%;
    top: 0;
    right: 0;
    max-width: 800px;
    min-width: 600px;
    box-shadow: -8px 0 16px 0 rgba(69,69,69,0.40);
    z-index: 1;

    @media (max-width: $small) {
      min-width: auto;
      width: 100vw;
    }
  }

  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all 0.5s ease-out;
    z-index: 2;
  }
  .slide-fade-enter-active .body, .slide-fade-leave-active .body {
    min-height: calc(100vh - 90px);
    transition: all 0.2s ease-in;
  }
  .slide-fade-leave-active .body {
    transition: all 0.2s ease-in;
  }

  .slide-fade-enter-active .slide-in-container, .slide-fade-leave-active .slide-in-container {
    //transition: all 0.5s ease-out;
    //height: 100%;

    //z-index: 2;
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(100%);
  }

  .modal-header {
    display:flex;
    justify-content: flex-end;
    align-items: center;
    width:100%;
    padding: 15px 0;
    font-family: OpenSans-Bold, sans-serif;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 30px;
    height:30px;
    span {
      width: 100%;
      font-size: 20px;
    }
    .close-btn {
      color: white;
      font-weight: 600;
      cursor: pointer;
    }
  }

.close-button {
    float: right;
    margin: 3px 18px 0 18px;
    color: white;
    background: none;
    cursor: pointer;
    width: 30px;
}

.body {
  transition: all 0.2s ease-in;
  min-height: 100vh;
  background: white;
  height: calc(100% - 60px);
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: $header-change) {
    min-width: auto;
    width: 100%;
    min-height: calc(100vh - 100px);
    height: calc(100% - 110px);

  }
  .notif-line {
    background-color: white;
    border-top: 1px solid lightgray;

    .notif-unread {
      background-color: #CCE5E9;
      padding: 10px 13px;
    }

    .notif-read {
      padding: 10px 13px;
    }
  }

  .notif-line:last-child {
    border-bottom: 1px solid lightgray;
  }

  .no-notif {
    margin-top: 20px;
  }
}

.task-bar {
  height: 26px;
  display: flex;
  justify-content: flex-end;

  .all-read {
    display: flex;
    align-items: center;
    height: 100%;
    padding-right: 4px;
    color: $primary-color;
    font-size: 14px;
    cursor: pointer;
  }

  .all-delete {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 13px 0 4px;
    color: $primary-color;
    font-size: 14px;
    cursor: pointer;
  }
}

  /* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background:  #CCE5E9;
  border-radius: 100px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
  border-radius: 100px;
  border: 2px solid #CCE5E9;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background:rgb(243, 252, 255);
}

</style>
